export default __webpack_public_path__ + "static/media/icon-forget-whatsapp.7bd0334b.webp";